import {
  createAxiosServiceInstance,
  createAxiosHeaderlessInstance
} from '../api';

export const axios = createAxiosServiceInstance();

// Instance for download file without any headers
export const axiosHeaderless = createAxiosHeaderlessInstance();
